import i18next from 'i18next';

i18next.addResources('es_CL', 'BlockTableRow', {
  Product: 'Producto',
  Modifier: 'Modificador',
  undefined: 'Indefinido',
  toDayThis: 'Hasta {{endDateNew}}'
});

i18next.addResources('es_CR', 'BlockTableRow', {
  Product: 'Producto',
  Modifier: 'Modificador',
  undefined: 'Indefinido',
  toDayThis: 'Hasta {{endDateNew}}'
});
